export { useHorizontalNavMenuGroup as default };
import * as vue_composition_api from '@vue/composition-api';
import core_layouts_utils from '@core/layouts/utils';

// import store from '@/store'

function useHorizontalNavMenuGroup(item) {
  // ------------------------------------------------
  // childDropdown
  // ------------------------------------------------
  const refChildDropdown = vue_composition_api.ref(null);
  const openChildDropdownOnLeft = vue_composition_api.ref(false);

  // ------------------------------------------------
  // isActive
  // ------------------------------------------------
  const isOpen = vue_composition_api.ref(false);
  const updateGroupOpen = val => {
    isOpen.value = val;
    if (val) {
      vue_composition_api.nextTick(() => {
        const childDropdownWidth = refChildDropdown.value.offsetWidth;
        const windowContentWidth = window.innerWidth - 16;
        const {
          left: childDropdownLeft
        } = refChildDropdown.value.getBoundingClientRect();
        const shallDropLeft = childDropdownLeft + childDropdownWidth - windowContentWidth;
        openChildDropdownOnLeft.value = shallDropLeft > 0;

        // Add scroll to child dd if don't have much space

        const refChildDropdownTop = refChildDropdown.value.getBoundingClientRect().top;
        const refChildDropdownHeight = refChildDropdown.value.getBoundingClientRect().height;
        if (window.innerHeight - refChildDropdownTop - refChildDropdownHeight - 28 < 1) {
          const maxHeight = window.innerHeight - refChildDropdownTop - 70;
          refChildDropdown.value.style.maxHeight = `${maxHeight}px`;
          refChildDropdown.value.style.overflowY = 'auto';
          refChildDropdown.value.style.overflowX = 'hidden';
        }
      });
    } else {
      openChildDropdownOnLeft.value = false;
    }
  };

  // ------------------------------------------------
  // isActive
  // ------------------------------------------------
  const isActive = vue_composition_api.ref(false);
  const updateIsActive = () => {
    isActive.value = core_layouts_utils.isNavGroupActive(item.children);
  };
  return {
    isOpen,
    isActive,
    updateGroupOpen,
    updateIsActive,
    refChildDropdown,
    openChildDropdownOnLeft
  };
}

